var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_32089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.0625C6.20206 14.0625 4.93327 13.6776 3.85407 12.9565C2.77488 12.2354 1.93374 11.2105 1.43704 10.0114C0.940343 8.81222 0.810384 7.49272 1.0636 6.21972C1.31682 4.94672 1.94183 3.7774 2.85961 2.85961C3.7774 1.94183 4.94672 1.31682 6.21972 1.0636C7.49272 0.810384 8.81222 0.940343 10.0114 1.43704C11.2105 1.93374 12.2354 2.77488 12.9565 3.85407C13.6776 4.93327 14.0625 6.20206 14.0625 7.5C14.0625 9.24049 13.3711 10.9097 12.1404 12.1404C10.9097 13.3711 9.24049 14.0625 7.5 14.0625ZM7.5 1.875C6.38748 1.875 5.29995 2.2049 4.37492 2.82299C3.44989 3.44107 2.72892 4.31957 2.30318 5.34741C1.87744 6.37524 1.76604 7.50624 1.98309 8.59739C2.20013 9.68853 2.73586 10.6908 3.52253 11.4775C4.3092 12.2641 5.31148 12.7999 6.40262 13.0169C7.49376 13.234 8.62476 13.1226 9.6526 12.6968C10.6804 12.2711 11.5589 11.5501 12.177 10.6251C12.7951 9.70006 13.125 8.61252 13.125 7.5C13.125 6.00816 12.5324 4.57742 11.4775 3.52253C10.4226 2.46764 8.99185 1.875 7.5 1.875Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65156 10.3125L7.03125 7.69219V3.28125H7.96875V7.30312L10.3125 9.65156L9.65156 10.3125Z",
    fill: "#E6E7E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_32089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonTime);
export default __webpack_public_path__ + "static/media/carbon-time.e354ba8472893dbe3ac50857c9efcfdd.svg";
export { ForwardRef as ReactComponent };